import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate } from "react-router-dom";
import { USER_ROLES } from "@/constants/auth";
import useAuthStore from "@/context/auth/useAuthStore";
import { DASHBOARD_PAGE } from "@/router/paths";
export default function RequireRole({ children, allowedRoles }) {
    const { userRole } = useAuthStore();
    const isSuperAdmin = userRole === USER_ROLES.SUPERADMIN;
    const hasRequiredRole = userRole && allowedRoles.includes(userRole);
    if (!isSuperAdmin && !hasRequiredRole) {
        return /*#__PURE__*/ _jsx(Navigate, {
            to: DASHBOARD_PAGE,
            replace: true
        });
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
}
